// extracted by mini-css-extract-plugin
export default {"root":"TabSelector_root__CB7Kq","tab":"TabSelector_tab__zS6n7","tabActive":"TabSelector_tabActive__SKK6P"};